var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("Transactions")]), _c('v-alert', {
    staticClass: "testnet_alert",
    attrs: {
      "text": "",
      "type": "info",
      "rounded": "0"
    }
  }, [_c('p', {
    staticClass: "description"
  }, [_vm._v(" Notice: This explorer only indexes the X-Chain and P-Chain. To view C-Chain transactions (EVM chain), click "), _c('a', {
    staticClass: "bold c_chain_link",
    attrs: {
      "href": _vm.cChainURL
    }
  }, [_vm._v("here")]), _vm._v(". ")])]), _c('p', {
    staticClass: "chain"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("You are viewing transactions for")]), _c('v-tooltip', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c('span', _vm._g({
          staticClass: "chain_tag",
          style: {
            backgroundColor: _vm.pChain.darkColor
          }
        }, on), [_vm._v(_vm._s(_vm.pChain.name))])];
      }
    }])
  }, [_c('span', [_vm._v("The P-Chain is the metadata blockchain on Avalanche, managing validators and custom subnets. Validators stake AVAX on the P-Chain to secure the network.")])]), _c('v-tooltip', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var on = _ref2.on;
        return [_c('span', _vm._g({
          staticClass: "chain_tag margin-left",
          style: {
            backgroundColor: _vm.xChain.darkColor
          }
        }, on), [_vm._v(_vm._s(_vm.xChain.name))])];
      }
    }])
  }, [_c('span', [_vm._v("The X-Chain is the default asset blockchain on Avalanche enabling the creation and instant exchange of assets. This blockchain is for transfers that benefit from high-throughput and instant finality. Think X for eXchanging assets. ")])]), _c('v-tooltip', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref3) {
        var on = _ref3.on;
        return [_c('span', _vm._g({
          staticClass: "chain_tag margin-left",
          style: {
            backgroundColor: _vm.cChain.darkColor
          }
        }, on), [_vm._v(_vm._s(_vm.cChain.name) + " (atomic txs only)")])];
      }
    }])
  }, [_c('span', [_vm._v("The C-Chain is the default smart contract blockchain on Avalanche and enables the creation of any Ethereum-compatible applications and assets with lower fees and faster transactions.")])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }